import * as types from './types'
import storage from '@/plugins/storage'
export default {
  business: {
    sid: '',
    name: '',
    timezone: '',
    phone: '',
    phoneCC: '',
    billSameAsPrimary: true,
    primaryAddress: {
      street: '',
      city: '',
      state: '',
      postalCode: ''
    }
  },
  devices: JSON.parse(storage.local.getItem(types.SESSION_DEVICES)) || []
}



// WEBPACK FOOTER //
// ./src/store/modules/location/state.js